import { AUTH_REDUCER_ACTIONS, AuthActionCreator, AuthReducerFunction } from '../types';

export const loggedOut: AuthActionCreator<AUTH_REDUCER_ACTIONS.LOGOUT> = () => ({
  type: AUTH_REDUCER_ACTIONS.LOGOUT
});

export const loggedOutReducer: AuthReducerFunction<AUTH_REDUCER_ACTIONS.LOGOUT> = () => ({
  isAuthenticated: false
});
